module.exports = __webpack_public_path__ + "static/media/loading.20c8b55a.svg";